// services/service.services.ts

import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IService } from "../serviceModel";

// Get All Services
export const getAllService = createAsyncThunk(
  "Service/FindAllService",
  async (filter?: { Title?: string }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/FindAllService`,
        {
          Title: filter?.Title || "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Create Service
export const createService = createAsyncThunk(
  "Service/InsertService",
  async (ServiceData: { Title: string }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/InsertService`,
        ServiceData,
      );
      SuccessToast(response.data?.Details || "Service created successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Update Service
export const updateService = createAsyncThunk(
  "Service/UpdateService",
  async (ServiceData: { ID: number; Title: string; IsActive: boolean }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/UpdateService`,
        ServiceData,
      );
      SuccessToast(response.data?.Details || "Service updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Delete Service
export const deleteService = createAsyncThunk(
  "Service/DeleteService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/DeleteService`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Service deleted successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Get Service By ID
export const getServiceByID = createAsyncThunk(
  "Service/FindByIDService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/FindByIDService`,
        { ID },
      );
      const result = response.data?.Data;
      return {
        ID: result.ID,
        Title: result.Title,
        IsActive: result.IsActive ? 1 : 2,
      } as IService;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Get All Active Services
export const getAllActiveService = createAsyncThunk(
  "Service/FindAllActiveService",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Service/FindAllActiveService`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Services:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Active/Inactive Service
export const ActiveInactiveService = createAsyncThunk(
  "Service/ActiveInActiveService",
  async (formData: { ID: number; IsActive: boolean }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/ActiveInActiveService`,
        formData,
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating service status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
